module.exports = __webpack_public_path__ + "img/vehicle.8be600c9.png";